import { gql } from '../../__generated__';
import { AdfsItem, ClientAuthorizationItem, LicenseAdfsItem } from '../../interfaces.graphql';
export const GET_ADFS = gql(`
  query GetAdfs {
    adfs: allAdfsConfig {
      ...AdfsItem
    }
  }
`);
export const GET_SINGLE_ADFS = gql(`
  query GetSingleAdfs($id: ID!) {
    adfs: getSingleAdfs(id: $id) {
      ...AdfsItem
    }
  }
`);
export const GET_SINGLE_ADFS_BY_BKS_ID = gql(`
  query GetSingleAdfsByBksId($bksID: Int!) {
    adfs: getSingleAdfsByBksID(bksID: $bksID) {
      ...AdfsItem
    }
  }
`);
export const CREATE_ADFS = gql(`
  mutation CreateAdfs($input: CreateADFSInput!) {
    createADFS(input: $input) {
      ...LicenseAdfsItem
    }
  }
`);
export const UPDATE_GENERAL_SETTING = gql(`
  mutation UpdateGeneralSetting($input: UpdateGeneralSettingInput!) {
    updateGeneralSetting(input: $input) {
      ...AdfsItem
    }
  }
`);
export const CREATE_CLIENT_AUTHORIZATION = gql(`
  mutation CreateClientAuthorization($input: CreateClientAuthorizationInput!) {
    createClientAuthorization(input: $input) {
      ...ClientAuthorizationItem
    }
  }
`);
export const UPDATE_ADVANCE_SETTING = gql(`
  mutation UpdateAdvanceSetting($input: UpdateAdvanceSettingInput!) {
    updateAdvanceSetting(input: $input) {
      ...AdfsItem
    }
  }
`);
export const DELETE_CLIENT_AUTHORIZATION = gql(`
  mutation DeleteClientAuthorization($input: DeleteClientAuthorizationInput!) {
    deleteClientAuthorization(input: $input) {
      ...AdfsItem
    }
  }
`);
export const DELETE_ADFS = gql(`
  mutation DeleteAdfs($input: DeleteADFSInput!) {
    deleteADFS(input: $input) {
      ...AdfsItem
    }
  }
`);
